<template>
  <v-dialog class="rounded-lg" @update:model-value="closeModal" :model-value="modelValue" max-width="700">
    <v-card>
      <v-card-title
        class="d-flex justify-space-between align-center padding_sm"
      >
        <span class="bold-body-md">Mailing Address Required: Your Global Alts New York Conference Badge</span>
        <div @click="closeModal" @keydown="closeModal" class="cursor-pointer">
          <IconMaterial color="#64748b" icon="close" :size="24" />
        </div>
      </v-card-title>
      <v-card-text>
        <div class="regular-body-md mb-2">
          Attending <span class="bold-body-md">Global Alts New York</span>? If you have a U.S. address, you can receive your event badge by mail!
        </div>
        <div class="regular-body-md mb-2">
          <span class="bold-body-md">Submit your shipping details by April 15th</span> to get your badge in advance.
        </div>
        <div class="regular-body-md mb-2">
          <span class="bold-body-md">International attendees,</span> badges will only be available for pick-up onsite at registration. However, we still encourage you to submit your address to stay informed about upcoming Roadshows and networking opportunities.
        </div>
        <IconnButton class="my-4" text="Submit Your Address" @onClick="onUpdateAddressClick"/>
        <div class="regular-body-md">We look forward to seeing you at the event!</div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script setup>
import {
  defineProps, defineEmits, computed,
} from 'vue';
import IconMaterial from '@design_system_v3/components/atoms/IconMaterial.vue';
import { useStore } from 'vuex';
import IconnButton from '@design_system_v3/components/atoms/IconnButton.vue';

defineProps({
  modelValue: Boolean,
});

const store = useStore();

const emits = defineEmits(['update:modelValue']);

const contactId = computed(() => store.getters['main/contactId']);
const contactGuid = computed(() => store.getters['main/contactGuid']);

const onUpdateAddressClick = () => {
  window.postMessage({
    name: 'iConnectionsEventBus',
    type: 'changeMFe',
    path: `/event/updateaddress/${contactId.value}/${contactGuid.value}`,
  }, '*');
};

const closeModal = () => {
  emits('update:modelValue', false);
};

</script>
<style scoped lang="scss">
@import '@foundation';
</style>
